import React from "react";
import styled from "styled-components";

export const VerticalContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HorizontalContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const HorizontalMarginSmall = styled.div`
  width: 6px;
`;

export const HorizontalMargin = styled.div`
  width: 12px;
`;

export const VerticalMargin = styled.div`
  height: 12px;
`;
